import { NoopTaskLogger } from "./taskLogger.js";
import { getGlobal, registerGlobal, unregisterGlobal } from "../utils/globals.js";
const API_NAME = "logger";
const NOOP_TASK_LOGGER = new NoopTaskLogger();
export class LoggerAPI {
    static _instance;
    constructor() { }
    static getInstance() {
        if (!this._instance) {
            this._instance = new LoggerAPI();
        }
        return this._instance;
    }
    disable() {
        unregisterGlobal(API_NAME);
    }
    setGlobalTaskLogger(taskLogger) {
        return registerGlobal(API_NAME, taskLogger);
    }
    debug(message, metadata) {
        this.#getTaskLogger().debug(message, metadata);
    }
    log(message, metadata) {
        this.#getTaskLogger().log(message, metadata);
    }
    info(message, metadata) {
        this.#getTaskLogger().info(message, metadata);
    }
    warn(message, metadata) {
        this.#getTaskLogger().warn(message, metadata);
    }
    error(message, metadata) {
        this.#getTaskLogger().error(message, metadata);
    }
    trace(name, fn) {
        return this.#getTaskLogger().trace(name, fn);
    }
    #getTaskLogger() {
        return getGlobal(API_NAME) ?? NOOP_TASK_LOGGER;
    }
}
//# sourceMappingURL=index.js.map